import { DispatcherDivisionSelect } from "./search-field-selects";
import { OfferCardSectionT, UseGetOffersFilters } from "../../../domain";
import React, { useCallback, useState } from "react";
import { SetFilterT, useOffers } from "../../store";

type OfferDispatchDivisionProps = {
  tab: OfferCardSectionT;
};

export const OfferDispatchDivision = ({
  tab,
}: OfferDispatchDivisionProps): React.ReactElement => {
  const { setTypeFilters } = useOffers();

  const [tempFilters, setTempFilters] = useState<{
    queue: UseGetOffersFilters;
    history: UseGetOffersFilters;
  }>({
    queue: {},
    history: {},
  });

  const setTempFilter = useCallback<(tab: OfferCardSectionT) => SetFilterT>(
    (tab) => (name, value) => {
      setTempFilters((prev) => {
        const nextFilters = {
          ...prev,
          [tab]: {
            ...prev[tab],
            [name]: value,
          },
        };
        setTypeFilters(tab, nextFilters[tab]);

        return nextFilters;
      });
    },
    [setTypeFilters]
  );

  return (
    <DispatcherDivisionSelect
      name="dispatch-division"
      keyProp="dispatch_division_id"
      selectedValue={tempFilters[tab].dispatch_division_id}
      noError={true}
      onChangeValue={(value) => {
        if (!Array.isArray(value)) {
          setTempFilter(tab)(
            "dispatch_division_id",
            value ? value.dispatch_division_id : undefined
          );
        }
      }}
      placeholder="Dispatch Division"
    />
  );
};
